import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
import OurBackground from './img/ourbg.jpg';
import CoreValues from './img/core.jpg';
import HistoryData from "./data/history.json";
class CoreValue extends Component {
  state = {
    history:[]
  }
  componentWillMount(){
      this.setState({
        history:HistoryData,
      });

  }

  render() {
    const opts = {
      width:"1040",
      height:"584",
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    };

    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>
                <div className="AboutUsImage">

                  <Image className="AboutUsImage" src={OurBackground} />
                </div>
                <div className="AboutUsTitle">
                  Our Core Value
                </div>
                <div className="AboutUsText left">
                香港中區扶輪社於2009年正式創立。初創時期由33位不同領域的年輕企業領袖及專業人士組成。本社的服務使命是透過貢獻自身的專業知識，提供多元化的社會服務，籍以凝聚社會大眾，為建立和諧美好的香港作出貢獻。
<br/><br/>
中區扶輪社的中心價值 (Core Value)
<br/><br/>
前瞻‧敏銳‧關懷‧直接 <br/>
前瞻：看清事物的真義，順應時勢，做有深遠影響而利己利人的事。 <br/>
敏銳：有批判及分析環境的能力，迅速反應，做事果斷及緊貼社會潮流。 <br/>
關懷：關心社會，關顧社會被莫視而有完整生存需要的人仕。 <br/>
直接：身體力行，直接參與，務使資源得以充分利用於受眾。<br/>
<br/>
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default CoreValue;
